<template>
    <div class="accordion-wrapper" @open-parent-accordion="openAccordion()">
        <ui-accordion :is-passive="true" :is-open="isOpen">
            <template slot="head">
                <div class="accordion-wrapper--head" @click="toggleAccordion">
                    <ui-icon class="ui-accordion--icon" :symbol="isOpen ? 'remove' : 'add'" size="medium"/>
                    <h2 class="ui-accordion--title u-reset" :id="anchor">
                        {{ title }}
                    </h2>
                </div>
            </template>
            <template ref="body" slot="body">
                <slot/>
            </template>
        </ui-accordion>
    </div>
</template>

<script>
    import { UiAccordion, UiIcon } from '@dreipol/vue-ui/src/components';

    export default {
        components: {
            UiAccordion, UiIcon,
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            anchor: {
                type: String,
                required: false,
                default: null,
            },
        },
        data: function() {
            return {
                isOpen: false,
                savedAnchor: null,
            };
        },
        methods: {
            toggleAccordion() {
                this.isOpen = !this.isOpen;
            },
            openAccordion() {
                this.isOpen = true;
            },
            dispatchEventToOpenParentAccordions() {
                const event = new CustomEvent('open-parent-accordion', {
                    bubbles: true,
                    cancelable: false,
                    composed: true,
                });
                this.$el.dispatchEvent(event);
            },
            saveAnchor() {
                this.savedAnchor = window.location.hash.substring(1);
                history.replaceState(null, '', '#');
            },
            scrollTo() {
                const scrollTarget = document.getElementById(this.anchor);
                if (!scrollTarget) {
                    return;
                }
                window.addEventListener('load', () => {
                    setTimeout(() => {
                        scrollTarget.scrollIntoView({ behavior: 'smooth' });
                    }, 300);
                    setTimeout(() => {
                        this.$el.classList.add('accordion-wrapper--highlight');
                    }, 600);
                });
            },
            addSavedAnchorBackToUrl() {
                window.addEventListener('load', () => {
                    setTimeout(() => {
                        history.replaceState(null, '', `#${ this.savedAnchor }`);
                    }, 1000);
                });
            },
        },
        mounted() {
            const anchor = window.location.hash;
            if (anchor === `#${ this.anchor }`) {
                this.saveAnchor();
                this.openAccordion();
                this.dispatchEventToOpenParentAccordions();
                this.scrollTo();
                this.addSavedAnchorBackToUrl();
            }
        },
    };
</script>
